module.exports = __webpack_public_path__ + "static/media/star.caad7ec9.svg";